import { render, staticRenderFns } from "./FormatValidator.vue?vue&type=template&id=1a347e48&"
import script from "./FormatValidator.vue?vue&type=script&lang=ts&"
export * from "./FormatValidator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports